import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import bedIcon from '../../Components/SideBar/Icons/bed.svg'

import { FRONTEND_LINKS } from '../../Constants/FrontendLinks'
import claraLogo from '../../assets/images/clara-logo.png'

const DATA = {
    title: 'DATA',
    iconClosed: <FaIcons.FaPlus />,
    iconOpened: <FaIcons.FaMinus />,
    subNav: [

        {
            title: 'Patients',
            path: FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN,
            layout: 'data_profiling',
            icon: <MdIcons.MdHotel size={22} />,
            index: 1,
            action_id: 'data_review:view',
            sub_page: false,

        },
        {
            path: FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.SUBPAGES.PATIENTS.MAIN,
            sub_page: true,
            index: 1,
        },
        {
            path: FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.SUBPAGES.GROUPS.MAIN,
            sub_page: true,
            index: 1
        },


    ]
}

const WORKSPACE = {
    title: 'WORKSPACE',

    iconClosed: <FaIcons.FaPlus />,
    iconOpened: <FaIcons.FaMinus />,

    subNav: [
        {
            title: 'Projects',
            layout: 'admin_studies',
            path: FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.STUDIES.MAIN,
            icon: <MdIcons.MdLocalLibrary size={18} />,
            index: 10,
            action_id: 'project:view',
            sub_page: false,

        },
        {
            title: 'Sites',
            layout: 'admin_sites',
            path: FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.SITES.MAIN,
            icon: <MdIcons.MdApartment size={18} />,
            index: 11,
            action_id: 'site:view',
            sub_page: false,

        },
        {
            title: 'Users',
            layout: 'admin_user_management',
            path: FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.MAIN,
            icon: <FaIcons.FaUserCog size={18} />,
            index: 9,
            action_id: 'user:view',
            sub_page: false,

        },
        {
            path: FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.SUBPAGES.USERS.SUBPAGES.ACTIVITY.MAIN,
            sub_page: true,
            index: 9,
        },
        {
            path: FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.SUBPAGES.ROLES_AND_PERMISSIONS.MAIN,
            sub_page: true,
            index: 9,
        },
    ]

}

const INTERNAL = {
    title: 'INTERNAL',
    iconClosed: <FaIcons.FaPlus />,
    iconOpened: <FaIcons.FaMinus />,
    subNav: [
        {
            title: 'Backstage',
            layout: 'internal',
            path: FRONTEND_LINKS.SUBPAGES.INTERNAL.MAIN,
            icon: <MdIcons.MdBuild size={18} />,
            index: 12,
            sub_page: false,
            action_id: 'env:manage',
        },
    ]
}

const CLARA = {
    title: 'CLARA',
    iconClosed: <FaIcons.FaPlus />,
    iconOpened: <FaIcons.FaMinus />,
    subNav: [
        {
            title: 'Clara',
            path: FRONTEND_LINKS.SUBPAGES.CLARA.MAIN,
            icon: <img src={claraLogo} alt="" style={{ width: 20, height: 20 }} />,
            index: 2,
            action_id: 'data_review:view',
            feature_flag: 'FEATURE_FLAG_CLARA',
            sub_page: false,
        },
        {
            title: 'Documents',
            path: FRONTEND_LINKS.SUBPAGES.CLARA.SUBPAGES.DOCUMENTS.MAIN,
            icon: <MdIcons.MdDescription size={18} />,
            index: 3,
            action_id: 'data_review:view',
            feature_flag: 'FEATURE_FLAG_CLARA',
            sub_page: false,
        },
    ]
}

const sections = [DATA, CLARA, WORKSPACE, INTERNAL]

export const SidebarData = sections